import { Component } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from 'environments/environment';
import { AuthService } from '../../_services';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../_services/loader.service'; 
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
import Swal from 'sweetalert2'
import { utils, write, WorkBook } from 'xlsx';  
import { saveAs } from 'file-saver'; 

declare var $: any;
 
@Component({
  templateUrl: './primaryVehicleAssignment.html',
})

export class PrimaryAssignmentComponent {
  public prjId: any
  public userId: any 
  public showLoader: boolean
  public vehAssignmntList: any  
  public vtsDataNotFound=false  
  public search:any;
  public selectedRow : Number;
  constructor(private http : HttpClient , private auth: AuthService, public routes: ActivatedRoute, public router: Router, private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });  
}

    /*
    * Get VEHICLE HISTORY DEATILS 
    */
    getVehAssignmntReport() {
        this.loaderService.display(true);
        var vehType="Primary"
        this.http.get(environment.apiUrl + 'reports/getPrmySecondAssignment?prjId=' + this.prjId+'&vehType='+vehType+'').subscribe(data => {
         this.vehAssignmntList = data
        if (this.vehAssignmntList.length > 0) {  
            this.loaderService.display(false);
            this.vtsDataNotFound=false
        } else { 
            this.loaderService.display(false);
            this.vtsDataNotFound=true
        }},
        error => {
            this.loaderService.display(false);
            Swal({
            type: 'error',
            title: 'Oops...',
            text: 'An Error Occurred Please Try Again',
            })
        });
    } 
        
    /*
    * This Method Is use to Download the Vehicles Report into Excel File 
    */
   importVehAssignmentReport(vehAssignmntList){
    const ws_name = 'VtsReport';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(vehAssignmntList);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type:'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'PrmyAssignmentReport.xlsx');
    }s2ab(s){
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xFF;
        };
        return buf;
    }   
  ngOnInit() {
    this.prjId = this.auth.getAuthentication().projectId
    this.userId = this.auth.getAuthentication().id 
    this.getVehAssignmntReport();
  }
}


// WEBPACK FOOTER //
// ./src/app/reports/vehicleReport/primaryVehicleAssignment.ts